import React from 'react';
import Particles from './Particles';
import useFadeIn from './useFadeIn';

const PHONE = '+48 536 030 706';
const PHONE_HREF = 'tel:+48536030706';
const WHATSAPP_HREF = 'https://wa.me/48536030706?text=Dzień%20dobry%2C%20chciałbym%2Fm%20zapytać%20o%20wynajem%20Infiniti%20FX35.';

export default function CTA() {
  const ref = useFadeIn();

  return (
    <section
      id="contact"
      style={{
        padding: '120px 24px',
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #050a1a 0%, #0a1628 50%, #0d1f3c 100%)',
      }}
    >
      {/* Ambient glows */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          width: 700,
          height: 700,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          animation: 'glowPulse 4s ease-in-out infinite',
        }}
      />

      <Particles count={20} />

      <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 2 }}>
        <div ref={ref} className="fade-in-section">
          <p className="section-label" style={{ marginBottom: 16 }}>Rezerwacja</p>

          <h2
            style={{
              fontFamily: '"Playfair Display", Georgia, serif',
              fontSize: 'clamp(36px, 5vw, 60px)',
              fontWeight: 700,
              color: '#f4f5f7',
              lineHeight: 1.15,
              marginBottom: 20,
              letterSpacing: '-0.02em',
            }}
          >
            Zarezerwuj termin{' '}
            <span
              style={{
                background: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontStyle: 'italic',
              }}
            >
              już dziś
            </span>
          </h2>

          <p
            style={{
              fontSize: 16,
              color: 'rgba(244,245,247,0.55)',
              lineHeight: 1.7,
              marginBottom: 52,
              maxWidth: 520,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            Skontaktuj się z nami i sprawdź dostępność wybranego terminu.
            Oferta ustalana indywidualnie.
          </p>

          {/* Big phone number */}
          <a
            href={PHONE_HREF}
            style={{
              display: 'block',
              fontSize: 'clamp(28px, 5vw, 48px)',
              fontWeight: 700,
              color: '#f4f5f7',
              textDecoration: 'none',
              letterSpacing: '0.04em',
              marginBottom: 40,
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#60a5fa';
              e.currentTarget.style.textShadow = '0 0 40px rgba(59,130,246,0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#f4f5f7';
              e.currentTarget.style.textShadow = 'none';
            }}
          >
            {PHONE}
          </a>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href={PHONE_HREF}
              className="btn-primary"
              style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 10 }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.22 2 2 0 012 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14z" />
              </svg>
              Zadzwoń teraz
            </a>

            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline"
              style={{
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.098.546 4.067 1.5 5.785L0 24l6.37-1.47A11.942 11.942 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.846 0-3.574-.476-5.077-1.312l-.363-.215-3.782.872.891-3.682-.237-.38A9.97 9.97 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
              </svg>
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
